import { Link } from "react-router-dom";
import { channels } from "@/mocks/channels";
import { lives } from "@/mocks/lives";
import SectionHeading from "@/components/base/SectionHeading";

export default function ChannelShortcuts() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <SectionHeading
        eyebrow="频道快捷入口"
        icon="ri-apps-2-line"
        title="按兴趣挑选你的频道"
        subtitle="六大内容频道覆盖游戏、娱乐、教育、生活、体育与音乐，点开即可浏览该频道全部直播。"
      />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {channels.map((channel) => {
          const count = lives.filter((live) => live.channel === channel.key).length;
          return (
            <Link
              key={channel.key}
              to={`/category/${channel.key}`}
              className="group flex flex-col items-center text-center rounded-lg border border-background-200/70 bg-background-50 p-4 md:p-5 hover:border-primary-300 hover:bg-primary-50 transition-colors duration-300"
            >
              <span className="w-14 h-14 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${channel.icon} text-2xl text-primary-600 group-hover:text-background-50 transition-colors`} />
              </span>
              <span className="mt-3 font-heading text-sm md:text-base font-semibold text-foreground-950">
                {channel.name}
              </span>
              <span className="mt-1 text-xs text-foreground-500">{count} 场直播</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}